import React, {useState} from "react";
import {useRef} from "react";
import {Container, Typography, TextField, Button} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import axios from "axios";
import Map from "./Map"
import {TextDecrypt} from "../content/TextDecrypt";

import './Contact.css';

const useStyles = makeStyles((theme) => ({
    main: {
        maxWidth: '100vw',
        marginTop: '3em',
        marginBottom: "3em",
    },
    form: {
        width: '100%',
    },
    formfield: {
        width: '100%',
        marginBottom: '2rem',
    },
}));

const initialValue = {
    name: "",
    email: "",
    message: "",
}

export const Contact = () => {
    const [inputValue, setInputValue] = useState(initialValue);
    const {name, email, message} = inputValue
    const classes = useStyles();
    const greetings = "Say hello.";


    const change = (name, value) => setInputValue({...inputValue, [name]: value})

    const send = async () => {
        if (name && email && message) {
            await axios.post(`${process.env.REACT_APP_PATH}/portfolio/ContactMessage`, inputValue)
                .then(res => setInputValue(initialValue))
                .catch(err => console.log("ERROR", err))
        } else {
            alert("Please fill the details")
        }
    };


    return (
        <section id="contact">
            <Container component="main" className={classes.main} maxWidth="md">
                <div className="contact">
                    <div className="_form_wrapper">
                        <span className={classes.form}>
                            <TextField
                                id="outlined-name-input"
                                label="Name"
                                type="text"
                                size="small"
                                variant="filled"
                                name="name"
                                value={name}
                                onChange={(e) => change("name", e.target.value)}
                                className={classes.formfield}
                            />
                            <TextField
                                id="outlined-password-input"
                                label="Email"
                                type="email"
                                size="small"
                                variant="filled"
                                name="email"
                                value={email}
                                onChange={(e) => change("email", e.target.value)}
                                className={classes.formfield}
                            />
                            <TextField
                                id="outlined-password-input"
                                label="Message"
                                type="textarea"
                                size="small"
                                multiline
                                minRows={5}
                                variant="filled"
                                name="message"
                                value={message}
                                onChange={(e) => change("message", e.target.value)}
                                className={classes.formfield}
                            />
                            <button type="submit" value="Send" className="submit-btn">
                                <i className="fas fa-terminal"></i>
                                <Typography component='span' onClick={send}> Send Message</Typography>
                            </button>
                        </span>
                    </div>
                    <h1 className="contact_msg">
                        {/*<TextDecrypt text={greetings}/>*/}
                        <Map/>
                    </h1>
                </div>
            </Container>
        </section>
    );
};
